// extracted by mini-css-extract-plugin
export default {"block":"relatedCaseStudy-module--block--2M_Vp","relative":"relatedCaseStudy-module--relative--3bKx5","title":"relatedCaseStudy-module--title--1wrXs"};